import siteSeo from './site-seo.json';

export const PRODUCTION_ORIGIN = siteSeo.productionOrigin;
export const PAGE_METADATA = siteSeo.pages;
export type PublicPagePath = keyof typeof PAGE_METADATA;
